module.exports = __webpack_public_path__ + "h5/img/logo2.e365ed52.png";